import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToasterService} from 'angular5-toaster/dist/src/toaster.service';
import {BodyOutputType} from 'angular5-toaster/dist/src/bodyOutputType';
import {Language} from '../models/language';
import {ConfirmDialogComponent} from '../dialogs/confirm-dialag/confirm-dialag.component';
import {MatDialog} from '@angular/material';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

declare let $: any;
declare let CryptoJS: any;

@Injectable()
export class Utils {

  @BlockUI() blockUI: NgBlockUI;

  map = new Map<string, number>();


  constructor(public _translateService: TranslateService,
              private _dialog: MatDialog,
              private toasterService: ToasterService) {
    this.fillUrlMap();
  }

  fillUrlMap() {
    this.map.set('https://aqmola.pem.kz', 1);
    this.map.set('https://aktobe.pem.kz', 2);
    this.map.set('https://pavlodar.pem.kz', 12);
    this.map.set('https://astana.pem.kz', 15);
    this.map.set('https://nursultan.pem.kz', 15);
    this.map.set('https://zhetysu.pem.kz', 16);


    // dev
    this.map.set('http://10.25.72.50:8000', 2);
    this.map.set('http://10.25.72.50:7000', 15);

    this.map.set('http://10.25.72.16:5080', 2);
    this.map.set('http://10.25.72.16:5070', 15);

    this.map.set('http://apps.platonus.kz:5080', 2);
    this.map.set('http://apps.platonus.kz:5070', 15);

    this.map.set('http://localhost:4200', 15);
  }

  notifyError(description, additional) {
    this.notifyMessage({
      status: 'error',
      description: description,
      additional: additional
    }, null, null);
  }

  notifySuccess(description, additional) {
    this.toasterService.clear();
    this.toasterService.pop('success', this._translateService.instant(description), additional);
  }

  notifyInfo(description, additional) {
    this.toasterService.clear();
    this.toasterService.pop('info', this._translateService.instant(description), additional);
  }

  notifySaved(success: boolean) {
    if (success) {
      this.notifySuccess('saved', null);
    } else {
      this.notifySuccess('error_occurred', null);
    }
  }

  notifyDeleted(success: boolean) {
    if (success) {
      this.notifySuccess('deleted', null);
    } else {
      this.notifyError('error_occurred', null);
    }
  }

  notifyMessage(message, successFn, errorFn) {
    if (!message) {
      return;
    }
    this.toasterService.clear();
    // call callBackFunc
    if (typeof successFn === 'function' && message.status.toLowerCase() != 'error') {
      successFn();
    } else if (typeof errorFn === 'function') {
      errorFn();
    }
    let additional = '';
    if (message.additional && message.additional.length) {
      for (let i = 0; i < message.additional.length; i++) {
        additional += message.additional[i];
        if (i != message.additional.length - 1) {
          additional += '<br/>';
        }
      }
    }
    this.toasterService.pop({
      type: message.status.toLowerCase(),
      title: this._translateService.instant(message.description),
      body: additional,
      bodyOutputType: BodyOutputType.TrustedHtml
    });
  }


  checkMessage(message, successFn, errorFn) {
    if (message) {
      // call callBackFunc
      if (typeof successFn === 'function' && message.status.toLowerCase() != 'error') {
        successFn();
      } else if (typeof errorFn === 'function') {
        errorFn();
      }
    }
  }

  translateWith2List(list, p1, p2) {
    for (let i = 0; i < list.length; i++) {
      if (list[i][p1]) {
        list[i].name = list[i][p1] + ' ';
      } else {
        list[i].name = '';
      }
      list[i].name = list[i].name + this.getMultiValue(list[i], p2);
    }
    return list;
  }

  translateList(list, prop) {
    const resultList = [];
    if (list && list.length) {
      for (let i = 0; i < list.length; i++) {
        list[i][prop] = this.getMultiValue(list[i], prop);
        resultList.push(list[i]);
      }
    }
    return resultList;
  }

  translateListWithSort(list, prop) {
    return this.translateList(list, prop)
      .sort((a, b) => a[prop].localeCompare(b[prop]));
  }

  sortByName(obj) {
    obj.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }

  sortBy2Fields(list, field1, field2) {
    list.sort((a, b) => a[field1].localeCompare(b[field1]) || a[field2].localeCompare(b[field2]));
  }

  getMultiValue = function (obj, prop) {
    if (this._translateService.currentLang == Language.KAZAKH.code) {
      return obj[prop + 'Kz'] || '';
    } else if (this._translateService.currentLang == Language.ENGLISH.code) {
      return obj[prop + 'En'] || '';
    }
    return obj[prop + 'Ru'] || '';
  };

  getLangSuff = function (prop) {
    prop = prop || '';
    if (this._translateService.currentLang == Language.KAZAKH.code) {
      prop = prop + 'Kz';
    } else if (this._translateService.currentLang == Language.ENGLISH.code) {
      prop = prop + 'En';
    } else {
      prop = prop + 'Ru';
    }
    return prop;
  };

  confirmDialog(option, fn, fnNotConfirmed?) {
    option = option || {message: 'common.are_sure_to_delete'};
    option.message = option.message || 'common.are_sure_to_delete';
    let messageParams = {};
    if (option && option.messageParams) {
      messageParams = option.messageParams;
    }

    // option.acceptMessage
    // option.declineMessage

    option.message = this._translateService.instant(option.message, messageParams);

    if (option.closeAll) {
      this._dialog.closeAll();
    }

    const dialogRef = this._dialog.open(ConfirmDialogComponent, {
      maxWidth: '45%',
      // height: '110px',
      data: option
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          if (fn) {
            fn();
          }
        } else {
          if (fnNotConfirmed) {
            fnNotConfirmed();
          }
        }
      }
    );
  }

  blockStart(message?) {
    if (!message) {
      message = 'Подождите, идет загрузка...';
    }
    this.blockUI.start(this._translateService.instant(message));
  }

  blockStop() {
    if (this.blockUI.isActive) {
      this.blockUI.stop();
    }
  }

  encryptAES = function (text) {
    // Encrypt
    const cipherText = CryptoJS.AES.encrypt(text, 'save error');
    return cipherText.toString();
  };

  decryptAES = function (cipherText) {
    // Decrypt
    const bytes = CryptoJS.AES.decrypt(cipherText, 'save error');
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
  };

  getRegionIdByHost(host ?: string) {
    if (!host) {
      host = window.location['origin'];
    }
    if (this.map.get(host)) {
      return this.map.get(host);
    }
    return null;
  }

  validateIin(iin: String, birthDate: Date, sexId: number) {
    if (!iin || iin.length != 12 || !birthDate || !sexId) return false;
    birthDate = new Date(birthDate);
    if (sexId !== this.defineGender(Math.ceil(birthDate.getFullYear() / 100), iin)) return false;
    let year = birthDate.getFullYear().toString().substring(2, 4);
    let month = ("0"+(birthDate.getMonth()+1)).slice(-2).toString();
    let day = ("0" + birthDate.getDate()).slice(-2).toString();
    return iin.substring(0, 6) === (year + month + day);
  }

  defineGender(centuryOfBirth: number, iin: String) {
    let iin7Digit = Number.parseInt(iin.substring(6, 7));
    if (iin7Digit >= 1 && iin7Digit <= 6 && centuryOfBirth >= 19 && centuryOfBirth <= 21) {
      return iin7Digit % 2 === 0 ? 1 : 2;
    }
    return 0;
  }

  isEmpty(str: string) : boolean {
    return str == null || str.length == 0;
  }

  clearMessage() {
    this.toasterService.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Utils.ts